// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "Python语言及应用",
        "tec": "单中元",
        "week": "1-12周",
        "add": "教学楼C座405管理"
      },
      {
        "sub": "劳动与创造",
        "tec": "张丕振",
        "week": "18周",
        "add": "教学楼C座303教务"
      }
    ],
    [
      {
        "sub": "云计算原理与应用",
        "tec": "李鲍",
        "week": "1-11双周",
        "add": "教学楼C座404管理"
      },
      {
        "sub": "劳动与创造",
        "tec": "张丕振",
        "week": "18周",
        "add": "教学楼C座303教务"
      }
    ],
    {
      "sub": "操作系统原理",
      "tec": "才九荣",
      "week": "1-12周",
      "add": "实训楼F座302信息"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李进",
        "week": "1-8周",
        "add": "教学楼A座322电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "李进",
        "week": "9-12周",
        "add": "教学楼A座322电力"
      }
    ],
    0
  ],
  "2": [
    {
      "sub": "CTF竞赛",
      "tec": "李鲍",
      "week": "1-8周",
      "add": "教学楼C座402管理"
    },
    {
      "sub": "网络安全基础",
      "tec": "周振柳",
      "week": "1-12周",
      "add": "教学楼C座402管理"
    },
    0,
    0,
    0
  ],
  "3": [
    [
      {
        "sub": "云计算原理与应用",
        "tec": "李鲍",
        "week": "1-11周",
        "add": "教学楼C座404管理"
      },
      {
        "sub": "劳动与创造",
        "tec": "张丕振",
        "week": "18周",
        "add": "教学楼C座304教务"
      }
    ],
    [
      {
        "sub": "就业创业指导",
        "tec": "于天宇",
        "week": "1-5周",
        "add": "教学楼C座213教务"
      },
      {
        "sub": "劳动与创造",
        "tec": "张丕振",
        "week": "18周",
        "add": "教学楼C座304教务"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "Python语言及应用",
      "tec": "单中元",
      "week": "1-12周",
      "add": "教学楼C座403管理"
    },
    0,
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李进",
        "week": "1-8周",
        "add": "教学楼A座321电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "李进",
        "week": "9-12周",
        "add": "教学楼A座321电力"
      }
    ],
    0,
    0
  ],
  "5": [
    {
      "sub": "网络安全基础",
      "tec": "周振柳",
      "week": "1-12周",
      "add": "实训楼F座402信息"
    },
    {
      "sub": "操作系统原理",
      "tec": "才九荣",
      "week": "1-12周",
      "add": "实训楼F座302信息"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
